<template>
  <div>
    <div
      ref="tableEl"
      :class="$style.table"
    >
      <div :class="$style.th">
        <div
          v-for="(column, index) in columns"
          :key="column.field + index"
          :class="$style.td"
          :style="{ flexGrow: columns[index].width }"
          @click="changeSort(column)"
        >
          <div :class="[$style.tdInline, $style.colname]">
            {{ column.name }}
          </div>
          <img
            src="@/assets/images/icons/table/sort-arrow.svg"
            :class="[
              $style.tdInline,
              $style.arrow,
              {
                [$style.asc]: column.sort == 2,
                [$style.hidden]: column.sort == 0,
              },
            ]"
          >
        </div>
      </div>

      <div
        v-for="user in paginationUsers"
        :key="user.userId"
      >
        <div
          :class="[$style.tr, $style.user, $style.group]"
          @click="toggle(user)"
        >
          <div :class="[$style.expandButton, { [$style.expanded]: user.isExpanded }]" />
          <div :class="$style.td">
            <div :class="$style.bold">
              {{ user.userName }}
            </div>
            <div :class="$style.text">
              - {{ $t('reports.activeTime') }}
            </div>
            <div :class="$style.bold">
              {{ convertSecondsToDays(user.activeTime) }}
            </div>
          </div>
        </div>

        <div
          v-for="group in user.history"
          v-show="isPdfPage || user.isExpanded"
          :key="group.categoryName"
        >
          <div
            :class="[$style.tr, $style.group, $style.indent]"
            @click="toggle(group)"
          >
            <div :class="[$style.expandButton, { [$style.expanded]: group.isExpanded }]" />
            <div :class="$style.td">
              <div :class="$style.bold">
                {{ getCategoryName(group.categoryName) }}
              </div>
              <div :class="$style.text">
                - {{ $t('reports.activeTime') }}
              </div>
              <div :class="$style.bold">
                {{ convertSecondsToDays(group.activeTime) }}
              </div>
              <div :class="$style.percent">
                {{ group.percent }}% ОА
              </div>
            </div>
          </div>

          <div
            v-for="site in paginationLinks(group)"
            v-show="isPdfPage || group.isExpanded"
            :key="site.link"
            :class="[
              $style.tr,
              $style.indent,
              $style.colData,
              {
                [$style.red]: site.productivity === 0,
                [$style.green]: site.productivity === 1,
                [$style.yellow]: site.productivity === 2,
              },
            ]"
            @contextmenu.prevent="showMenu($event, user, site)"
          >
            <div
              v-for="(column, num) in columns"
              :key="column.name + num"
              :class="[$style.td, $style.data]"
              :style="{
                flexGrow: columns[num].width,
                marginLeft: getLeftMargin(column.field),
                paddingRight: getPadding(column.field),
              }"
            >
              <div
                :style="{
                  marginRight: getRightMargin(column.field),
                  borderRight: '0px',
                }"
              >
                <div v-if="!isVisibleName && !num">
                  {{ getCategoryName(group.categoryName) }}
                </div>
                <div v-else>
                  {{ getDataField(site[column.field], column.field) }}
                </div>
              </div>
            </div>
          </div>
          <paginate
            v-if="!isPdfPage && group.isExpanded && countPage(group) > 1"
            :page-count="countPage(group)"
            :click-handler="(page) => setPage(group, page)"
            :prev-text="'‹'"
            :next-text="'›'"
            :page="getPage(group)"
            :container-class="$style.pagination"
            :page-class="$style.page"
            :prev-class="$style.page"
            :next-class="$style.page"
            :active-class="$style.pageActive"
          />
        </div>
        <div
          v-if="user.activeTime && (isPdfPage || user.isExpanded) && chartsByUser[user.userId]"
          :class="{ [$style.apexchart]: !isPdfPage }"
        >
          <div :class="$style.chart">
            <apexchart
              :class="$style.chartContent"
              width="100%"
              height="300"
              type="pie"
              :options="chartsByUser[user.userId].categoryOptions"
              :series="chartsByUser[user.userId].categorySeries"
            />
          </div>

          <div
            v-if="!isVisibleName"
            :class="$style.chart"
          >
            <apexchart
              :class="$style.chartContent"
              width="100%"
              height="300"
              type="pie"
              :options="chartsByUser[user.userId].sitesOptions"
              :series="chartsByUser[user.userId].sitesSeries"
            />
          </div>
        </div>
      </div>
    </div>

    <context-menu
      v-show="isMenuVisible"
      id="notificationsContextmenu"
      :mouse-x="mouseX"
      :mouse-y="mouseY"
      :user-id="targetUser"
      :log-id="logId"
      :filter="targetFilter"
    />
  </div>
</template>

<script>
  import { convertSecondsToDays } from '@/helpers/format-date';
  import { getCategoryName } from '@/helpers/methods';
  import { getDataField } from '@/views/reports/users/worktime/table-field';
  import Paginate from 'vuejs-paginate';
  import Apexchart from 'vue-apexcharts';
  import ru from 'apexcharts/dist/locales/ru.json';
  import { isEmpty } from 'lodash';
  import ContextMenu from '@/components/common/contextmenu/stat-menu.vue';
  import { ROUTE_IDS, ROUTE_NAME_GROUP } from '@/components/pages/const/const';

  import { getColorString } from '@/components/pages/agents/drag-tree-table/utils';

  export default {
    components: {
      Paginate,
      Apexchart,
      ContextMenu,
    },
    props: ['columns', 'tableData', 'isVisibleName', 'categorys'],
    data() {
      return {
        perUser: 3,
        perPage: 10,
        maxLoadedPages: 3,
        groupPages: {},
        mouseX: null,
        mouseY: null,
        targetUser: null,
        targetFilter: null,
        logId: null,
        isMenuVisible: false,
        loadedUserPages: [1],
        scrollContainer: null,
        rafPending: false,
        closeMenuHandler: null,
        isFilling: false,
        contentResizeObserver: null,
      };
    },
    computed: {
      isPdfPage() {
        return this.$route.query.pdf === 'true';
      },
      sortedColumn() {
        const index = this.columns.findIndex((x) => x.sort > 0);
        if (index === -1) {
          return { index: -1, sort: 0, field: null };
        }

        return {
          index,
          sort: this.columns[index].sort,
          field: this.columns[index].field,
        };
      },
      countUser() {
        return Math.ceil(this.tableData.length / this.perUser);
      },
      paginationUsers() {
        if (this.isPdfPage || this.tableData.length === 1) {
          return this.tableData;
        }

        return this.loadedUserPages.reduce((result, page) => {
          const start = (page - 1) * this.perUser;
          const end = start + this.perUser;

          return result.concat(this.tableData.slice(start, end));
        }, []);
      },

      colorMap() {
        const currentGroup = ROUTE_NAME_GROUP[this.$route.name];
        if (!this.categorys) return {};
        const group = this.categorys.data.result[currentGroup];
        const colorMap = group.reduce((acc, { groupName, color }) => {
          acc[groupName] = getColorString(color);
          return acc;
        }, {});

        return colorMap;
      },
      chartsByUser() {
        const map = {};

        this.paginationUsers.forEach((user) => {
          const category = this.buildCategoryChartData(user);
          const sites = this.buildSitesChartData(user);

          map[user.userId] = {
            categorySeries: category.series,
            categoryOptions: this.buildCategoryChartOptions(category),
            sitesSeries: sites.series,
            sitesOptions: this.buildSitesChartOptions(sites),
          };
        });

        return map;
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.scrollContainer = document.getElementById('printable');

        if (this.scrollContainer) {
          this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });
          this.ensureScroll();
        }
        if (window.ResizeObserver && this.$refs.tableEl) {
          this.contentResizeObserver = new ResizeObserver(() => this.ensureScroll());
          this.contentResizeObserver.observe(this.$refs.tableEl);
        }
      });
    },
    beforeDestroy() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
      if (this.closeMenuHandler) {
        window.removeEventListener('click', this.closeMenuHandler);
        this.closeMenuHandler = null;
      }
    },
    methods: {
      doubleRaf() {
        return new Promise((resolve) => {
          requestAnimationFrame(() => requestAnimationFrame(resolve));
        });
      },
      async ensureScroll() {
        if (this.isFilling) return;
        if (this.isPdfPage || !this.scrollContainer) return;

        this.isFilling = true;

        try {
          const container = this.scrollContainer;
          let guard = 0;

          while (
            container.scrollHeight <= container.clientHeight + 20 &&
            Math.max(...this.loadedUserPages) < this.countUser &&
            guard < 100
          ) {
            guard++;

            const lastPage = Math.max(...this.loadedUserPages);
            this.loadedUserPages = [...this.loadedUserPages, lastPage + 1];

            // eslint-disable-next-line no-await-in-loop
            await this.$nextTick();
            // eslint-disable-next-line no-await-in-loop
            await this.doubleRaf();
          }
        } finally {
          this.isFilling = false;
        }
      },
      handleScroll() {
        if (this.rafPending) return;
        this.rafPending = true;

        requestAnimationFrame(() => {
          this.rafPending = false;

          if (this.isPdfPage || this.tableData.length <= this.perUser || !this.scrollContainer) {
            return;
          }

          const c = this.scrollContainer;
          const atBottom = c.scrollTop + c.clientHeight >= c.scrollHeight - 40;
          const atTop = c.scrollTop <= 40;

          if (atBottom) this.loadNextUserPage();
          if (atTop) this.loadPreviousUserPage();
        });
      },

      async loadNextUserPage() {
        const lastPage = Math.max(...this.loadedUserPages);
        if (lastPage >= this.countUser) return;

        const container = this.scrollContainer;
        const willRemoveFirst = this.loadedUserPages.length >= this.maxLoadedPages;

        if (willRemoveFirst && container) {
          const oldHeight = container.scrollHeight;
          const oldTop = container.scrollTop;

          this.loadedUserPages = this.loadedUserPages.slice(1);
          await this.$nextTick();
          await this.doubleRaf();

          const removedHeight = oldHeight - container.scrollHeight;
          container.scrollTop = Math.max(0, oldTop - removedHeight);

          this.loadedUserPages = [...this.loadedUserPages, lastPage + 1];
        } else {
          this.loadedUserPages = [...this.loadedUserPages, lastPage + 1];
        }

        await this.$nextTick();

        this.ensureScroll();
      },

      async loadPreviousUserPage() {
        const firstPage = Math.min(...this.loadedUserPages);
        if (firstPage <= 1) return;

        const container = this.scrollContainer;
        if (!container) return;

        const oldTop = container.scrollTop;
        const oldHeight = container.scrollHeight;

        this.loadedUserPages = [firstPage - 1, ...this.loadedUserPages];
        await this.$nextTick();
        await this.doubleRaf();

        const addedHeight = container.scrollHeight - oldHeight;
        container.scrollTop = oldTop + addedHeight;

        if (this.loadedUserPages.length > this.maxLoadedPages) {
          this.loadedUserPages = this.loadedUserPages.slice(0, -1);
        }
      },
      isEmpty(object) {
        return isEmpty(object);
      },
      showMenu(event, user, site) {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;

        this.targetFilter = site.link.split('\\').pop();
        this.targetUser = user.userId;

        this.isMenuVisible = true;
        this.logId = ROUTE_IDS[this.$route.name];

        if (this.closeMenuHandler) {
          window.removeEventListener('click', this.closeMenuHandler);
        }

        this.closeMenuHandler = () => {
          this.isMenuVisible = false;
          window.removeEventListener('click', this.closeMenuHandler);
          this.closeMenuHandler = null;
        };

        setTimeout(() => {
          if (this.closeMenuHandler) {
            window.addEventListener('click', this.closeMenuHandler);
          }
        }, 0);
      },

      countPage(group) {
        return Math.ceil(this.sortedLinks(group).length / this.perPage);
      },
      getPage(group) {
        return this.groupPages[group?.categoryName] || 1;
      },
      setPage({ categoryName }, page) {
        this.$set(this.groupPages, categoryName, page);
      },

      paginationLinks(group) {
        const sorted = this.sortedLinks(group);
        if (this.isPdfPage) {
          return sorted;
        }

        const page = this.getPage(group);
        const start = (page - 1) * this.perPage;
        const end = start + this.perPage;
        return sorted.slice(start, end);
      },
      getCategoryName(name) {
        return getCategoryName(name);
      },
      getLeftMargin(field) {
        if (field === 'link' && this.columns.length === 4) return '-9px';
        return '0px';
      },
      getRightMargin(field) {
        if (field === 'name' && this.columns.length === 4) return '20px';
        return '0px';
      },
      getPadding(field) {
        if (field === 'link' && this.columns.length === 4) return '23px';
        return '';
      },
      getDataField(data, field) {
        return getDataField(data, field);
      },

      sortedLinks(group) {
        return group.events.slice(0).sort(this.compare);
      },

      compare(a, b) {
        const column = this.sortedColumn;
        if (column.index === -1) return 0;

        const key = column.field;
        let a1 = a[key];
        let b1 = b[key];

        if (column.index === 0) {
          a1 = a1?.toLowerCase();
          b1 = b1?.toLowerCase();
        }

        if (column.index === 2) {
          if (a === 2) a = 0.5;
          if (b === 2) b = 0.5;
        }

        switch (column.sort) {
          case 1:
            if (a1 > b1) return -1;
            if (a1 < b1) return 1;
            return 0;
          case 2:
            if (a1 < b1) return -1;
            if (a1 > b1) return 1;
            return 0;
          default:
            return 0;
        }
      },
      convertSecondsToDays(secNum) {
        return convertSecondsToDays(secNum);
      },
      toggle(folder) {
        folder.isExpanded = !folder.isExpanded;
      },
      changeSort(column) {
        const { sort } = column;
        this.columns.forEach((col) => {
          col.sort = 0;
        });
        if (sort === 1) {
          column.sort = 2;
        } else column.sort = 1;
      },
      normalizeSite(link) {
        if (!link) return 'Unknown';

        return link
          .replace(/^https?:\/\//, '')
          .replace(/^www\./, '')
          .split('/')[0]
          .toLowerCase();
      },
      buildSitesChartData(user) {
        const groups = Object.values(user.history || {});

        const flatEvents = groups.flatMap((group) =>
          (group.events || []).map((event) => ({
            ...event,
            categoryName: group.categoryName,
          })),
        );

        return {
          labels: flatEvents.map((event) => this.normalizeSite(event.link)),
          series: flatEvents.map((event) => event.duration || 0),
          colors: flatEvents.map((event) => this.colorMap[event.categoryName] || '#CCCCCC'),
          events: flatEvents,
        };
      },

      buildSitesChartOptions({ labels, colors, events }) {
        return {
          labels: labels.length ? labels : ['No data'],
          colors,

          chart: {
            type: 'pie',
            locales: [ru],
            defaultLocale: 'ru',
            animations: { enabled: false },
            redrawOnParentResize: false,
            redrawOnWindowResize: false,
          },

          legend: {
            width: 300,
            overflowY: 'auto',
            formatter: (seriesName, opts) => {
              const event = events[opts.seriesIndex];

              return `${seriesName} ${convertSecondsToDays(event?.duration)}`;
            },
          },

          dataLabels: {
            formatter: (val, opts) => {
              const event = events[opts.seriesIndex];

              return `${convertSecondsToDays(event?.duration)}`;
            },
          },

          tooltip: {
            y: {
              formatter: (value, opts) => {
                const event = events[opts.seriesIndex];

                return `${convertSecondsToDays(event?.duration)}`;
              },
            },
          },
        };
      },
      buildCategoryChartData(user) {
        const groups = Object.values(user.history || {});

        const labels = [];
        const series = [];
        const colors = [];

        groups.forEach((group) => {
          const name = getCategoryName(group.categoryName) ?? 'Unknown';

          labels.push(name);
          series.push(group?.activeTime || 0);
          colors.push(this.colorMap[group?.categoryName] || '#CCCCCC');
        });

        return { labels, series, colors, groups };
      },

      buildCategoryChartOptions({ labels, colors, groups }) {
        return {
          labels: labels.length ? labels : ['No data'],

          colors,

          legend: {
            width: 300,
            overflowY: 'auto',
            formatter: (seriesName, opts) => {
              const group = groups[opts.seriesIndex];
              return `${seriesName} ${convertSecondsToDays(group?.activeTime)} ${group?.percent}% ОА`;
            },
          },

          chart: {
            type: 'pie',
            locales: [ru],
            defaultLocale: 'ru',
            animations: { enabled: false },
            redrawOnParentResize: false,
            redrawOnWindowResize: false,
          },

          dataLabels: {
            formatter: (val, opts) => {
              const group = groups[opts.seriesIndex];
              const seconds = opts.w.config.series[opts.seriesIndex];
              return `${convertSecondsToDays(seconds)} ${group?.percent}% ОА`;
            },
          },
          tooltip: {
            y: {
              formatter: (value, opts) => {
                const group = groups[opts.seriesIndex];
                return `${convertSecondsToDays(group?.activeTime)} ${group?.percent}% ОА`;
              },
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss" module>
  .pagination {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin: 10px 0;
  }

  .page {
    cursor: pointer;
    padding: 2px;
    font-size: 12px;
  }

  .pageActive {
    font-weight: 600;
  }

  .table {
    display: flex;
    flex-flow: column nowrap;
    font-weight: 400;
    line-height: 1.5;
    flex: 1 1 auto;
    word-break: break-word;
    margin-bottom: 15px;
    padding-bottom: 20px;
    border-collapse: collapse;
    width: 100%;
  }

  .th {
    font-weight: 700;
    background: #dbf1ff;
    word-break: break-word;
    height: 31px;
    position: sticky;
    top: -2px;
    z-index: 3;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    cursor: pointer;
    font-weight: 400;
  }

  .th > .td {
    white-space: normal;
    word-break: break-word;
    border: 1px solid $borderColor;
    align-items: center;
    text-align: center;
    color: #232326;
    letter-spacing: -0.08px;
    font-size: 13px;
    padding: 4px 4px 4px 10px;
    cursor: pointer;
    justify-content: space-between;
  }

  .indent {
    margin-left: 20px;
  }

  .expandButton {
    flex-shrink: 0;
    margin-left: -27px;
    margin-right: 13px;
    width: 14px;
    height: 14px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $branchColor;
    background: $white;
    z-index: 2;

    &::before,
    &::after {
      content: '';
      background-color: $blue;
      width: 8px;
      height: 2px;
      position: absolute;
      transition: 0.25s ease-out;
    }

    &::before {
      transform: rotate(90deg);
    }

    &::after {
      transform: rotate(180deg);
    }

    &.expanded {
      &::before {
        transform: rotate(0);
      }

      &::after {
        transform: rotate(0);
      }
    }
  }

  .percent {
    padding: 0px 3px;
    color: #2985bf;
    font-weight: 700;
    background: $white;
    border: 1px solid #cecece;
    border-radius: 10px;
    height: 23px;
    display: flex;
    align-items: center;
  }

  .arrow {
    float: right;
    margin-top: 7px;
    margin-right: 5px;
    margin-left: auto;

    &.asc {
      transform: rotate(180deg);
    }

    &.hidden {
      visibility: hidden;
    }
  }

  .tdInline {
    display: inline-flex;
  }

  .colname {
    margin: auto;
  }

  .tr {
    display: flex;
    flex-flow: row nowrap;
    cursor: pointer;

    &:hover {
      background: $branchColor;
    }
  }

  .td {
    display: flex;
    flex-flow: row nowrap;
    flex-grow: 1;
    flex-basis: 0;
    word-break: break-word;
    overflow: inherit;
    text-overflow: ellipsis;
    min-width: 0px;
    white-space: inherit;
  }

  .data {
    border-left: 1px solid $borderColor;
    border-top: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    padding-left: 5px;
    font-size: 13px;
    line-height: 14px;
    letter-spacing: -0.24px;
    padding: 8px 4px 7px 20px;
    font-weight: 300;
  }

  .colData :nth-child(1) {
    margin-right: -10px;
  }

  .group {
    background: $light-gray;
    border: 1px solid #dfdfdf;
    font-size: 13px;
    line-height: 14px;
    letter-spacing: -0.24px;
    padding-top: 4px;
    padding-bottom: 3px;
    padding-left: 20px;
    position: relative;
    margin-top: 3px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
  }

  .user {
    margin-top: 7px;
  }

  .bold {
    font-weight: 500;
    padding: 5px 3px;
  }

  .text {
    padding: 5px 0;
  }

  .red {
    background-color: #ffb0b0;

    &:hover {
      background-color: $red;
    }
  }

  .green {
    background-color: #7cd890;

    &:hover {
      background-color: #1f8d37;
    }
  }

  .yellow {
    background-color: #ffecbc;

    &:hover {
      background-color: #d49a02;
    }
  }

  .blue {
    background-color: #94c2e0;

    &:hover {
      background-color: #1970a7;
    }
  }

  .apexchart {
    display: flex;
    flex-wrap: wrap;
  }

  .chart {
    flex: 1 1 500px;
    width: 500px;
  }

  .chart,
  .chartContent {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .noData {
    border: 1px solid #e3e3e3;
    border-top: none;
    font-size: 12px;
    padding: 6px;
  }
</style>
